import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Fade } from "@mui/material";

import { colors } from "../../constants/designTokens";

/**
 * Component: RouteLoading
 * Description: route-level lazy load 的 Suspense fallback。
 * Usage: <Suspense fallback={<RouteLoading />}>
 *
 * ⚠️ 本元件必須零相依，不可使用任何會 suspend 的 hook。
 * i18n 走 i18next-http-backend 非同步載入且 useSuspense 預設為 true，
 * 因此在此呼叫 useTranslation() 會讓 fallback 自己 suspend —— 沒有更外層的
 * Suspense 邊界能接住，React 會直接拋錯。故此處不顯示文字，只用 spinner。
 *
 * 延遲 SHOW_DELAY_MS 才顯示：chunk 已被瀏覽器快取時載入只需數十毫秒，
 * 立即顯示會造成一閃而過的視覺噪音，反而比空白更干擾。
 */

const SHOW_DELAY_MS = 300;

export default function RouteLoading() {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
		return () => clearTimeout(timer);
	}, []);

	return (
		<Fade in={visible} timeout={240}>
			<Box
				sx={{
					minHeight: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					backgroundColor: colors.bg,
				}}
			>
				<CircularProgress
					size={44}
					thickness={3.6}
					sx={{ color: colors.toggleActive }}
				/>
			</Box>
		</Fade>
	);
}
